import { Component, OnDestroy, OnInit, Renderer2, ViewChild, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Select2Data } from 'ng-select2-component';
import { Subject, Subscription } from 'rxjs';
import { DocumentService } from '../../../services/document.service';
import Swal from 'sweetalert2';
import { Helpers } from '../../../helpers/helpers';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { LogType } from '../../../enums/logType';
import { HttpEventType } from '@angular/common/http';
import { LastUpdatesModelDTO } from 'src/app/models/lastupdates';
import { LanguageApp } from 'src/app/config/datatable-config';
import { TrackingService } from 'src/app/services/tracking.service';
import { visibleContentAnimation } from 'src/app/animations';

@Component({
  selector: 'app-documents',
  templateUrl: './documentsTable.component.html',
  animations: [visibleContentAnimation]
})
export class documentsTableComponent implements OnInit, OnChanges, OnDestroy {
  @Input() idOrganization: string;
  @Input() idChild: string;

  routeSubscription: Subscription;

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  listenerFn!: () => void;

  idOrganizationFilter: string;
  idYearFilter: string = '0';
  idMonthFilter: string = '0';
  organizationMonth: boolean = false;
  public OrganizationData: Select2Data;
  public yearData: Select2Data;
  public monthData: Select2Data;

  progress: number = 0;
  showProgress: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private documentService: DocumentService,
    private trackingService: TrackingService,
    private toastr: ToastrService,
    private renderer: Renderer2,
    private helper: Helpers
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes["idChild"] &&
      changes["idChild"].previousValue !== undefined &&
      changes["idChild"].previousValue != changes["idChild"].currentValue
    ) {
      this.idOrganizationFilter = this.idChild;
      this.rerender();
    }
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);

    this.listenerFn = this.renderer.listen('document', 'click', (event) => {

      // PARA DESCARGAS ESTILO STIHL
      // if (event.target.hasAttribute('view-document-id')) {
      //   const id = event.target.getAttribute('view-document-id');
      //   const name = event.target.getAttribute('view-document-name');
      //   this.viewDocument(id, name);
      // } else if (event.target.hasAttribute('download-document-id')) {
      //   const id = event.target.getAttribute('download-document-id');
      //   const name = event.target.getAttribute('download-document-name');

      //   this.downloadDocument(id, name);
      // }

      // PARA DESCARGAS ESTILO RENAULT
      if (event.target.hasAttribute('track-document-id')) {
        const id = event.target.getAttribute('track-document-id');
        this.trackDocument(id);
      }
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    if (this.listenerFn) {
      this.listenerFn();
    }
  }

  ngOnInit(): void {
    this.idOrganizationFilter =
      this.idChild != null && this.idChild != ''
        ? this.idChild
        : this.idOrganization;
    this.loadData();
    this.setDatatable();
  }

  setDatatable() {
    const that = this;
    this.dtOptions = {
      responsive: false,
      paging: true,
      pageLength: 10,
      ordering: false,
      lengthChange: false,
      info: false,
      serverSide: true,
      language: LanguageApp.spanish_datatables,
      processing: false,
      ajax: (dataTablesParameters: any, callback) => {
        that.documentService
          .searchDataClient(
            dataTablesParameters,
            this.idOrganizationFilter,
            +this.idYearFilter,
            +this.idMonthFilter
          )
          .subscribe(
            (resp) => {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: resp.data
              });
            },
            (err) => {
              Swal.fire({
                icon: 'error',
                title: 'Erro ao recuperar os dados',
                text: 'Ocorreu um erro',
              });
            }
          );
      },
      columns: [
        { data: 'New' },
        { data: "ImageFile.FileUri" },
        { data: 'Business' },
        { data: 'Fecha' },
        { data: 'Documento' },
        { data: 'Formato' },
        { data: 'Opciones' },
      ],
      columnDefs: [
        {
          targets: [0],
          data: 'New',
          render: function (data, type, full) {
            var retorno = '';
            if (data == true) {
              retorno +=
                '<div class="orange s-12 bold">NOVO</div>';
            }
            if (data == false) {
              retorno +=
                '<div>&nbsp;</div>';
            }
            return retorno;
          },
        },
        {
          targets: [1],
          data: "ImageFile.FileUri",
          className: "align-middle",
          render: function (data, type, full) {
            var retorno = "";
            retorno = '<img class="img-fluid" src="' + data + '" width="180"/>';
            return retorno;
          }
        },
        {
          targets: [2],
          data: 'Business',
          render: function (data, type, full) {
            var retorno = '';
            if (full.Opciones.New == true) {
              retorno +=
                '<div class="tooltip__container--New left"><img src="/assets/images/icons/ico_New2.svg" width="22"/><div class="tooltip--black"></div></div>';
            }
            retorno +=
              '<div class="s-12">' +
              data +
              '</div>';
            return retorno;
          },
        },
        {
          targets: [3],
          data: 'Fecha',
          render: function (data, type, full) {
            var retorno = '';
            retorno =
              '<div class="date">' + data + '</div>';
            return retorno;
          },
        },

        {
          targets: [4],
          data: 'Documento',
          render: function (data, type, full) {
            var retorno =
              '<div>' + data.NombrePrincipal + '</div>';
            return retorno;
          },
        },
        {
          targets: [5],
          data: 'Formato',
          render: function (data, type, full) {
            var retorno = '<div class="format text-center">';
            retorno +=
              '<i class=" ' +
              data.TipoPrincipal +
              '" color:' +
              data.ColorPrincipal +
              '"></i>';
            retorno += '</div>';
            return retorno;
          },
        },
        {
          targets: [6],
          data: 'Opciones',
          className: 'text-start',
          render: function (data, type, full) {
            var retorno = '';

            //AQUI HAY UN DILEMA ENTRE SI LO HACEMOS COMO EN SLP ESPAÑA CON VISUALIZAR Y DESCARGAR CON LA BARRA DE PROGRESO
            // O SI LO HACEMOS AL ESTILO RENAULT CON UN URI
            // DE MOMENTO DEJO COMO EN RENAULT PERO ES POSIBLE QUE LO QUIERAN COMO EN SLP ESPAÑA ASÍ QUE LO DEJO COMENTADO
            // if (data.showEye) {
              // retorno +=
                // '<div class="btn-transparent btn-sm btn-icon" view-document-id="' + full.IdDocument + '" view-document-name="' + data.DownloadName + '"><div class="svg-icon"><svg viewBox="0 0 150 150"><use xlink:href=\'assets/images/icons/ico_eye_auto.svg#img\' href="assets/images/icons/ico_eye_auto.svg#img"></use></svg></div> Ver</div>';
              // '<a target="_blank" href="' + full.File.FileUri + '" class="btn-transparent btn-sm btn-icon"><div class="svg-icon"><svg viewBox="0 0 150 150"><use xlink:href=\'assets/images/icons/ico_eye_auto.svg#img\' href="assets/images/icons/ico_eye_auto.svg#img"></use></svg></div> Ver</a>';
            // }
            retorno +=
              // '<div class="btn-transparent btn-sm btn-icon" download-document-id="' + full.IdDocument + '" download-document-name="' + data.DownloadName + '"><div class="svg-icon"><svg viewBox="0 0 150 150"><use xlink:href=\'assets/images/icons/ico_download_auto.svg#img\' href="assets/images/icons/ico_download_auto.svg#img"></use></svg></div> Download</div>';
              '<a track-document-id="' + full.IdDocument + '" href="' + full.File.FileUri + '" class="btn-transparent btn-sm btn-icon"><div class="svg-icon"><svg viewBox="0 0 150 150"><use xlink:href=\'assets/images/icons/ico_download_auto.svg#img\' href="assets/images/icons/ico_download_auto.svg#img"></use></svg></div> Download</a>';
            return retorno;
          },
        },
      ],
      initComplete: function () {
        that.helper.animateDataTable(this[0])
      }
    };
  }



  loadData() {
    const that = this;

    this.documentService.GetOrganizationFilter(this.idOrganization).subscribe(
      (resp) => {
        this.organizationMonth = resp;
      },
      (err) => {
        Swal.fire({
          icon: 'error',
          title: 'Erro ao recuperar os dados',
          text: 'Ocorreu um erro',
        });
      }
    );

    this.documentService.GetDocumentOrganization(this.idOrganization).subscribe(
      (resp) => {
        var todosData = {
          value: this.idOrganization,
          label: 'TODAS AS ÁREAS',
        };
        resp.splice(0, 0, todosData);
        that.idOrganizationFilter = this.idOrganization;
        this.OrganizationData = resp;
        this.loadYear();
      },
      (err) => {
        Swal.fire({
          icon: 'error',
          title: 'Erro ao recuperar os dados',
          text: 'Ocorreu um erro',
        });
      }
    );
  }

  onChangeOrganization(event) {

    if (event == null) event = this.idOrganization;
    this.idChild = null;
    this.idMonthFilter = '0';
    this.idYearFilter = '0';
    this.loadYear();
  }

  onChangeYear(event) {
    if (event == null) event = 0;
    this.idMonthFilter = '0';
    this.loadMonth();
  }

  loadYear() {

    this.documentService.GetDocumentYear(this.idOrganizationFilter).subscribe(
      (resp) => {
        var todosData = { value: '0', label: 'TODOS OS ANOS' };
        resp.splice(0, 0, todosData);
        this.yearData = resp;
        //para quitar el selector de años
        //this.yearData = (this.idChild != null && this.idChild != '') ? [] : resp;
        this.loadMonth();
      },
      (err) => {
        Swal.fire({
          icon: 'error',
          title: 'Erro ao recuperar os dados',
          text: 'Ocorreu um erro',
        });
      }
    );
  }

  loadMonth() {
    this.documentService
      .GetDocumentMonth(this.idOrganizationFilter, +this.idYearFilter)
      .subscribe(
        (resp) => {
          var todosData = {
            value: '0',
            label: 'TODOS OS MESES',
          };
          resp.splice(0, 0, todosData);
          this.monthData = resp;
        },
        (err) => {
          Swal.fire({
            icon: 'error',
            title: 'Erro ao recuperar os dados',
            text: 'Ocorreu um erro',
          });
        }
      );
  }

  rerender(): void {
    if (this.idOrganizationFilter.length == 0) {
      this.idOrganizationFilter = this.idOrganization;
    }

    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }

  //#region MÉTODOS DE DESCARGA SI SE OPTA POR MANTENERLO COMO EN SLP ESPAÑA

  viewDocument(idDocument, name) {
    this.downloadDocument(idDocument, name, true);
  }

  downloadDocument(idDocument, documentName, view = false) {

    this.showProgress = true;

    this.documentService.getDocumentFileProgress(idDocument).subscribe(
      (event) => {

        if (event.type === HttpEventType.DownloadProgress) {

          this.progress = Math.round(100 * event.loaded / event.total);

        } else if (event.type === HttpEventType.Response) {

          this.showProgress = false;
          this.progress = 0;

          if (!view)
            saveAs(event.body, documentName);
          else {
            const url = URL.createObjectURL(event.body);
            window.open(url, "_blank");
          }
        }

      },
      (err) => {
        this.toastr.error(
          'No se pudo descargar el archivo',
          'Descarga de archivo',
          { timeOut: 2000 }
        );
      }
    );
    this.trackDocument(idDocument);
  }

  trackDocument(idDocument) {
    this.trackingService
      .trackDocument(idDocument, LogType.Download)
      .subscribe();
  }

  //#endregion
}
